import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Pagination from "@mui/material/Pagination";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import ProductData from "../../components/datatables/products/ProductData";
import { useDispatch, useSelector } from "react-redux";
import {
  getProducts,
  getSearchProducts,
} from "../../feature/products/productSlice";
import TextField from "@mui/material/TextField";
import axios from "axios";

const Product = () => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  // const [searchApiData, setSearchApiData] = useState([]);
  const { response, isLoading } = useSelector((state) => state.products);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    window.scrollTo({ top: "0", behavior: "smooth" });
    dispatch(getProducts());
  }, [dispatch]);

  // useEffect(() => {
  //   const fetchData = () => {
  //     if (!searchTerm) return;
  //     axios
  //       .post(`${process.env.REACT_APP_API_KEY}/product/get_search_products`, {
  //         search: searchTerm,
  //       })
  //       .then((response) => response.json())
  //       .then((result) => {
  //         console.log(result);
  //       });
  //   };
  //   fetchData();
  // }, [searchTerm]);

  const handleSearch = (e) => {
    // const lowerCase = e.target.value?.toLowerCase();
    setSearchTerm(e.target.value);
    dispatch(getSearchProducts(e.target.value));
  };

  const getPages = () => {
    if (!isLoading) return response.totalPages;
  };

  return (
    <Box component={Paper} minWidth={100} elevation={0}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        px={3}
        py={2}
      >
        <Typography variant='h3'>Products</Typography>

        <TextField
          type='search'
          size='small'
          value={searchTerm}
          onChange={handleSearch}
          // helperText='...Search'
          id='searchbox'
          label='...Search'
        />
      </Box>
      <Divider />
      <Box px={3} my={3}>
        <ProductData />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          m: 5,
        }}
      >
        <Pagination
          count={getPages()}
          variant='outlined'
          showFirstButton
          showLastButton
          shape='rounded'
          onChange={(e, value) => {
            dispatch(getProducts(value - 1));
          }}
        />
      </Box>
    </Box>
  );
};

export default Product;
